<template>
  <div class="home-container">
    <!-- 顶部导航 -->
    <header class="home-header">
      <div class="logo-wrapper">
        <img src="../assets/logo.svg" alt="Logo" class="logo">
        <span class="logo-text">SmartAI</span>
      </div>
      <div class="nav-links">
        <a href="#features" class="nav-link">功能</a>
        <a href="#advantages" class="nav-link">优势</a>
        <a href="#about" class="nav-link">关于我们</a>
      </div>
      <div class="auth-buttons">
        <el-button @click="goToLogin" class="login-btn" type="text">登录</el-button>
        <el-button @click="goToLogin" class="register-btn" type="primary">免费使用</el-button>
      </div>
    </header>

    <!-- 主要内容区 -->
    <main>
      <!-- 英雄区域 -->
      <section class="hero-section">
        <div class="hero-background">
          <div class="hero-shapes">
            <div class="shape shape-1"></div>
            <div class="shape shape-2"></div>
            <div class="shape shape-3"></div>
            <div class="shape shape-4"></div>
            <div class="shape-glow"></div>
          </div>
          <div class="hero-grid"></div>
        </div>

        <div class="hero-content">
          <h1 class="hero-title">
            <span class="text-gradient">智能AI应用</span>
            <span class="hero-title-break">一站式管理平台</span>
          </h1>
          <p class="hero-desc">
            快速构建、管理和部署AI应用，让AI技术为您的业务赋能
          </p>
          <div class="hero-actions">
            <el-button type="primary" size="large" class="action-button primary-button"
              @click="goToLogin">立即开始</el-button>
            <el-button size="large" plain class="action-button" @click="scrollToFeatures">了解更多</el-button>
          </div>
          <div class="hero-stats">
            <div class="stat-item">
              <div class="stat-number">100+</div>
              <div class="stat-label">企业用户</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-number">50+</div>
              <div class="stat-label">AI模型支持</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-number">99.9%</div>
              <div class="stat-label">服务可用性</div>
            </div>
          </div>
        </div>

        <div class="hero-visual">
          <div class="visual-container">
            <div class="visual-platform">
              <img src="../assets/logo.svg" alt="Platform" class="platform-icon">
              <div class="platform-glow"></div>
            </div>
            <div class="visual-modules">
              <div class="module module-1">
                <i class="el-icon-cpu"></i>
                <span>大语言模型</span>
              </div>
              <div class="module module-2">
                <i class="el-icon-data-analysis"></i>
                <span>知识库</span>
              </div>
              <div class="module module-3">
                <i class="el-icon-set-up"></i>
                <span>工作流</span>
              </div>
              <div class="module module-4">
                <i class="el-icon-connection"></i>
                <span>渠道接入</span>
              </div>
              <div class="connection c1"></div>
              <div class="connection c2"></div>
              <div class="connection c3"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 功能区域 -->
      <section id="features" class="features-section">
        <h2 class="section-title">核心功能</h2>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon model-icon">
              <i class="el-icon-cpu"></i>
            </div>
            <h3>模型管理</h3>
            <p>连接并管理多种AI模型，满足不同场景的智能需求</p>
          </div>

          <div class="feature-card">
            <div class="feature-icon workflow-icon">
              <i class="el-icon-set-up"></i>
            </div>
            <h3>工作流编排</h3>
            <p>可视化工作流设计，无代码实现复杂AI应用逻辑</p>
          </div>

          <div class="feature-card">
            <div class="feature-icon plugin-icon">
              <i class="el-icon-magic-stick"></i>
            </div>
            <h3>插件扩展</h3>
            <p>丰富的插件生态，轻松扩展AI能力边界</p>
          </div>

          <div class="feature-card">
            <div class="feature-icon connect-icon">
              <i class="el-icon-connection"></i>
            </div>
            <h3>多渠道接入</h3>
            <p>支持网页、App、微信等多种渠道，统一管理AI服务</p>
          </div>
        </div>
      </section>

      <!-- 优势区域 -->
      <section id="advantages" class="advantages-section">
        <h2 class="section-title">平台优势</h2>
        <div class="advantages-grid">
          <div class="advantage-item">
            <div class="advantage-number">01</div>
            <h3>简单易用</h3>
            <p>无需编程经验，拖拽式界面，5分钟即可构建AI应用</p>
          </div>

          <div class="advantage-item">
            <div class="advantage-number">02</div>
            <h3>灵活扩展</h3>
            <p>模块化设计，支持自定义开发，满足个性化需求</p>
          </div>

          <div class="advantage-item">
            <div class="advantage-number">03</div>
            <h3>数据安全</h3>
            <p>企业级安全保障，数据加密传输与存储</p>
          </div>

          <div class="advantage-item">
            <div class="advantage-number">04</div>
            <h3>成本可控</h3>
            <p>按需付费，资源高效利用，降低AI应用开发成本</p>
          </div>
        </div>
      </section>

      <!-- 关于我们 -->
      <section id="about" class="about-section">
        <div class="about-bg-wrapper">
          <div class="about-bg-gradient"></div>
          <div class="about-bg-pattern"></div>
          <div class="about-bg-circle c1"></div>
          <div class="about-bg-circle c2"></div>
          <div class="about-bg-line l1"></div>
          <div class="about-bg-line l2"></div>
        </div>

        <div class="about-container">
          <h2 class="section-title" data-text="关于我们">关于我们</h2>

          <div class="about-content">
            <div class="about-left">
              <div class="about-company-header">
                <div class="company-badge">
                  <div class="badge-inner">
                    <span>SINCE</span>
                    <strong>2021</strong>
                  </div>
                  <div class="badge-glow"></div>
                </div>
                <div class="company-title">
                  <h3 class="company-name">广东上游科技</h3>
                  <div class="company-slogan">AI工业化的先行者</div>
                </div>
              </div>

              <div class="about-paragraphs">
                <p class="about-paragraph">
                  <span class="highlight-text">Smart.AI</span>
                  是广东上游科技打造的工业级AI智能体操作系统。基于模块化设计，整合多模态大模型引擎、动态知识库、自动化流程组件等核心模块，提供全链路智能体开发解决方案。平台通过可视化编辑器实现智能体零代码部署，适配主流企业通信协议，快速对接IM/协作系统，精准服务营销自动化、智能服务中枢、企业效能优化等业务场景。
                </p>
                <p class="about-paragraph">
                  广东上游科技汇聚了来自<span class="company-tag">科大讯飞</span>、<span class="company-tag">平安集团</span>、<span
                    class="company-tag">字节跳动</span>及<span class="company-tag">阿里</span>等企业的AI工程化专家。作为国内首批实现<span
                    class="highlight-text">LLM+RAG+Agent</span>技术商用的先锋团队，始终践行"AI工业化"理念，通过标准化智能体生产流程，推动人工智能技术从实验室走向生产线，赋能开发者与企业构建可持续进化的AI业务闭环。
                </p>
              </div>
            </div>

            <div class="about-right">
              <div class="technology-showcase">
                <div class="tech-bg"></div>
                <div class="tech-overlay"></div>
                <div class="tech-grid"></div>

                <div class="tech-center-circle">
                  <div class="pulse-ring"></div>
                  <div class="center-core">
                    <span class="core-text">SmartAI</span>
                  </div>
                </div>

                <div class="tech-orbit">
                  <div class="orbit-path"></div>
                  <div class="orbit-node n1">
                    <div class="node-icon"><i class="el-icon-cpu"></i></div>
                    <div class="node-label">LLM</div>
                  </div>
                  <div class="orbit-node n2">
                    <div class="node-icon"><i class="el-icon-data-analysis"></i></div>
                    <div class="node-label">RAG</div>
                  </div>
                  <div class="orbit-node n3">
                    <div class="node-icon"><i class="el-icon-connection"></i></div>
                    <div class="node-label">Agent</div>
                  </div>
                </div>

                <div class="data-stream">
                  <div class="stream-particle p1"></div>
                  <div class="stream-particle p2"></div>
                  <div class="stream-particle p3"></div>
                  <div class="stream-particle p4"></div>
                  <div class="stream-particle p5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA区域 - 美化版 -->
      <section class="cta-section">
        <div class="cta-background">
          <div class="cta-bg-shapes">
            <div class="cta-shape shape1"></div>
            <div class="cta-shape shape2"></div>
            <div class="cta-shape shape3"></div>
          </div>
          <div class="cta-bg-pattern"></div>
        </div>

        <div class="cta-container">
          <div class="cta-content">
            <h2 class="cta-title">准备好开始使用<span>SmartAI</span>了吗？</h2>
            <p class="cta-description">免费注册，立即体验强大的AI应用管理平台，让AI技术为您的业务赋能</p>

            <div class="cta-actions">
              <el-button type="primary" size="large" class="cta-button" @click="goToLogin">
                <i class="el-icon-right action-icon"></i>
                <span>免费使用</span>
              </el-button>

              <div class="cta-features">
                <div class="feature-tag"><i class="el-icon-check"></i> 免费试用</div>
                <div class="feature-tag"><i class="el-icon-check"></i> 快速部署</div>
                <div class="feature-tag"><i class="el-icon-check"></i> 7×24小时支持</div>
              </div>
            </div>
          </div>

          <div class="cta-visual">
            <div class="visual-decoration">
              <div class="deco-circle c1"></div>
              <div class="deco-circle c2"></div>
              <div class="deco-circle c3"></div>
              <div class="deco-line l1"></div>
              <div class="deco-line l2"></div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="home-footer">
      <div class="footer-content">
        <div>© 2024 SmartAI 版权所有</div>
        <div class="footer-links">
          <a href="#">隐私政策</a>
          <a href="#">服务条款</a>
          <a href="#">联系我们</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      isLoaded: false
    }
  },
  mounted () {
    // 确保页面完全加载后再显示动画元素
    setTimeout(() => {
      this.isLoaded = true
    }, 300)
  },
  methods: {
    goToLogin () {
      this.$router.push('/login')
    },
    scrollToFeatures () {
      document.getElementById('features').scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
};
</script>

<style scoped>
/* 全局样式 */
.home-container {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #333;
  line-height: 1.6;
}

section {
  padding: 80px 0;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 60px;
  color: #303133;
}

/* 顶部导航 */
.home-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 80px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
  height: 64px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
}

.logo {
  height: 32px;
  width: 32px;
  margin-right: 10px;
}

.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-link {
  color: #606266;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #409EFF;
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}

.login-btn {
  font-size: 15px;
}

.register-btn {
  font-size: 15px;
}

/* 英雄区域 */
.hero-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 140px 80px 100px;
  background: linear-gradient(160deg, #ffffff 0%, #f5f7fa 100%);
  min-height: 650px;
  position: relative;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.hero-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.4;
  filter: blur(40px);
}

.shape-1 {
  top: -100px;
  right: 10%;
  width: 300px;
  height: 300px;
  background: rgba(64, 158, 255, 0.15);
  animation: float-slow 15s infinite ease-in-out;
}

.shape-2 {
  bottom: -150px;
  left: 5%;
  width: 350px;
  height: 350px;
  background: rgba(103, 194, 58, 0.1);
  animation: float-slow 20s infinite ease-in-out reverse;
}

.shape-3 {
  top: 30%;
  left: 20%;
  width: 180px;
  height: 180px;
  background: rgba(230, 162, 60, 0.1);
  animation: float-slow 12s infinite ease-in-out 2s;
}

.shape-4 {
  bottom: 20%;
  right: 15%;
  width: 200px;
  height: 200px;
  background: rgba(146, 84, 222, 0.1);
  animation: float-slow 18s infinite ease-in-out 3s;
}

.shape-glow {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background: radial-gradient(circle at 70% 30%, rgba(64, 158, 255, 0.07) 0%, rgba(64, 158, 255, 0) 60%);
}

.hero-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(64, 158, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(64, 158, 255, 0.03) 1px, transparent 1px);
  background-size: 40px 40px;
  opacity: 0.6;
}

.hero-content {
  max-width: 580px;
  position: relative;
  z-index: 1;
  padding-right: 40px;
}

.hero-title {
  font-size: 52px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 28px;
  line-height: 1.2;
}

.text-gradient {
  background: linear-gradient(90deg, #409EFF, #53a8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: block;
  letter-spacing: -0.5px;
}

.hero-title-break {
  display: block;
  margin-top: 6px;
  letter-spacing: -0.5px;
}

.hero-desc {
  font-size: 18px;
  color: #606266;
  margin-bottom: 36px;
  line-height: 1.6;
  font-weight: 400;
}

.hero-actions {
  display: flex;
  gap: 16px;
  margin-bottom: 50px;
}

.action-button {
  padding: 15px 30px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.primary-button {
  box-shadow: 0 10px 20px rgba(64, 158, 255, 0.2);
}

.primary-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 25px rgba(64, 158, 255, 0.25);
}

.hero-stats {
  display: flex;
  align-items: center;
  gap: 30px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #409EFF;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #909399;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: linear-gradient(to bottom, rgba(64, 158, 255, 0.05), rgba(64, 158, 255, 0.2), rgba(64, 158, 255, 0.05));
}

.hero-visual {
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
}

.visual-container {
  position: relative;
  width: 480px;
  height: 480px;
}

.visual-platform {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.platform-icon {
  width: 70px;
  height: 70px;
  animation: pulse-subtle 3s infinite ease-in-out;
}

.platform-glow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(64, 158, 255, 0.2) 0%, rgba(64, 158, 255, 0) 70%);
  border-radius: 24px;
  filter: blur(15px);
  z-index: -1;
}

.visual-modules {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.module {
  position: absolute;
  width: 100px;
  height: 100px;
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.07);
  transition: transform 0.3s ease;
}

.module:hover {
  transform: translateY(-5px);
}

.module i {
  font-size: 28px;
  margin-bottom: 8px;
}

.module-1 {
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
}

.module-1 i {
  color: #409EFF;
}

.module-2 {
  top: 50%;
  left: 8%;
}

.module-2 i {
  color: #67C23A;
}

.module-3 {
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
}

.module-3 i {
  color: #E6A23C;
}

.module-4 {
  top: 50%;
  right: 8%;
}

.module-4 i {
  color: #9254DE;
}

.module span {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.connection {
  position: absolute;
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.2), rgba(64, 158, 255, 0.6), rgba(64, 158, 255, 0.2));
  height: 2px;
  z-index: 1;
}

.connection::before,
.connection::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.6);
  top: -2px;
}

.connection::before {
  left: 0;
}

.connection::after {
  right: 0;
}

.c1 {
  top: 31%;
  left: 50%;
  width: 120px;
  transform: translateX(-50%) rotate(90deg);
}

.c2 {
  width: 140px;
  top: 50%;
  left: 20%;
  transform: rotate(0deg);
}

.c3 {
  width: 140px;
  top: 50%;
  right: 20%;
  transform: rotate(0deg);
}

@keyframes pulse-subtle {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}

@keyframes float-slow {

  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(20px, 20px);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .hero-section {
    padding: 120px 40px 80px;
  }

  .visual-container {
    width: 400px;
    height: 400px;
  }

  .hero-content {
    max-width: 500px;
  }

  .hero-title {
    font-size: 46px;
  }
}

@media (max-width: 960px) {
  .hero-section {
    flex-direction: column;
    padding: 120px 40px 60px;
    align-items: center;
    text-align: center;
  }

  .hero-content {
    padding-right: 0;
    margin-bottom: 60px;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-stats {
    justify-content: center;
  }

  .visual-container {
    width: 380px;
    height: 380px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 100px 20px 50px;
  }

  .hero-title {
    font-size: 40px;
  }

  .hero-desc {
    font-size: 16px;
  }

  .stat-number {
    font-size: 24px;
  }

  .visual-container {
    width: 340px;
    height: 340px;
  }

  .module {
    width: 90px;
    height: 90px;
  }

  .module i {
    font-size: 24px;
  }
}

/* 功能区域 */
.features-section {
  background-color: #fff;
  padding: 80px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  padding: 40px 20px;
  border-radius: 8px;
  background-color: #fff;
  text-align: center;
  transition: all 0.3s;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.03);
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.feature-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.feature-icon i {
  font-size: 28px;
  color: #fff;
}

.model-icon {
  background-color: #409EFF;
}

.workflow-icon {
  background-color: #67C23A;
}

.plugin-icon {
  background-color: #E6A23C;
}

.connect-icon {
  background-color: #9254DE;
}

.feature-card h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #303133;
}

.feature-card p {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

/* 优势区域 */
.advantages-section {
  background-color: #f5f7fa;
  padding: 80px;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.advantage-item {
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 8px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.advantage-number {
  font-size: 56px;
  font-weight: 700;
  color: rgba(64, 158, 255, 0.08);
  position: absolute;
  top: 10px;
  right: 10px;
}

.advantage-item h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #303133;
  position: relative;
}

.advantage-item p {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  position: relative;
}

/* 高级的关于我们样式 */
.about-section {
  position: relative;
  padding: 0;
  overflow: hidden;
  z-index: 1;
  background: linear-gradient(to bottom, #ffffff 0%, #f8fafd 100%);
}

.about-bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.about-bg-gradient {
  position: absolute;
  top: -50%;
  right: -20%;
  width: 70%;
  height: 200%;
  background: radial-gradient(ellipse at center, rgba(64, 158, 255, 0.03) 0%, rgba(64, 158, 255, 0) 70%);
  transform: rotate(-15deg);
}

.about-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.05;
  background-image:
    linear-gradient(rgba(64, 158, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(64, 158, 255, 0.1) 1px, transparent 1px);
  background-size: 40px 40px;
  background-position: center center;
}

.about-bg-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.05;
  border: 1px solid rgba(64, 158, 255, 0.5);
}

.about-bg-circle.c1 {
  top: -100px;
  right: -100px;
  width: 400px;
  height: 400px;
}

.about-bg-circle.c2 {
  bottom: -200px;
  left: -100px;
  width: 600px;
  height: 600px;
  opacity: 0.03;
}

.about-bg-line {
  position: absolute;
  background: linear-gradient(90deg, rgba(64, 158, 255, 0) 0%, rgba(64, 158, 255, 0.1) 50%, rgba(64, 158, 255, 0) 100%);
  height: 1px;
  width: 100%;
}

.about-bg-line.l1 {
  top: 20%;
  transform: rotate(-5deg);
}

.about-bg-line.l2 {
  bottom: 30%;
  transform: rotate(3deg);
}

.about-container {
  padding: 120px 0;
  position: relative;
  z-index: 1;
}

.section-title {
  position: relative;
  display: inline-block;
  margin: 0 auto 70px;
  padding-bottom: 15px;
  color: #303133;
  text-align: center;
  width: 100%;
}

.section-title:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #409EFF, rgba(64, 158, 255, 0.5));
  transform: translateX(-50%);
  border-radius: 2px;
}

.section-title::before {
  content: attr(data-text);
  position: absolute;
  opacity: 0.03;
  font-size: 100px;
  font-weight: 900;
  top: -60px;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translateX(-50%);
  color: #409EFF;
  white-space: nowrap;
}

.about-content {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 80px;
  gap: 80px;
}

.about-left {
  flex: 1;
  position: relative;
}

.about-company-header {
  margin-bottom: 40px;
  display: flex;
  align-items: center;
}

.company-badge {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 25px;
  perspective: 1000px;
}

.badge-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #3a8ee6 0%, #53a8ff 100%);
  color: white;
  box-shadow:
    0 10px 20px rgba(64, 158, 255, 0.2),
    0 6px 10px rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  transform: rotate(-5deg);
  position: relative;
  z-index: 1;
  transition: transform 0.5s ease;
}

.badge-inner:hover {
  transform: rotate(0deg) translateY(-5px);
}

.badge-glow {
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  background: rgba(64, 158, 255, 0.5);
  filter: blur(20px);
  opacity: 0.4;
  border-radius: 14px;
  z-index: 0;
  transform: rotate(-5deg);
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.company-badge:hover .badge-glow {
  opacity: 0.6;
  transform: rotate(0deg) translateY(-5px);
}

.badge-inner span {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: 0.9;
}

.badge-inner strong {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.company-title {
  flex: 1;
}

.company-name {
  font-size: 36px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  position: relative;
  display: inline-block;
  background: linear-gradient(90deg, #303133, #636363);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.company-slogan {
  font-size: 16px;
  color: #909399;
  font-weight: 400;
}

.about-paragraphs {
  position: relative;
  margin-bottom: 40px;
}

.about-paragraph {
  font-size: 16px;
  line-height: 1.8;
  color: #606266;
  margin-bottom: 24px;
  position: relative;
  text-align: justify;
}

.highlight-text {
  color: #409EFF;
  font-weight: 600;
}

.company-tag {
  display: inline-block;
  background: rgba(64, 158, 255, 0.08);
  color: #409EFF;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 14px;
  margin: 0 2px;
}

/* 右侧技术展示区 - 升级设计 */
.about-right {
  flex: 1;
  position: relative;
}

.technology-showcase {
  position: relative;
  height: 500px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow:
    0 20px 40px rgba(0, 10, 50, 0.1),
    0 10px 30px rgba(64, 158, 255, 0.08);
  background: linear-gradient(145deg, #fcfdff 0%, #f5f9ff 100%);
}

.tech-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.6;
}

.tech-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 30%, rgba(244, 247, 252, 0.7) 70%);
}

.tech-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(rgba(64, 158, 255, 0.08) 1px, transparent 1px);
  background-size: 30px 30px;
  background-position: center center;
}

.tech-center-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.center-core {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #409EFF 0%, #53a8ff 100%);
  border-radius: 50%;
  box-shadow: 0 0 30px rgba(64, 158, 255, 0.5);
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.center-core:hover {
  transform: scale(1.05);
}

.core-text {
  color: white;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border: 2px solid rgba(64, 158, 255, 0.3);
  border-radius: 50%;
  z-index: 1;
  animation: pulse-animation 3s infinite ease-out;
}

@keyframes pulse-animation {
  0% {
    width: 80px;
    height: 80px;
    opacity: 1;
  }

  100% {
    width: 240px;
    height: 240px;
    opacity: 0;
  }
}

.tech-orbit {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.orbit-path {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  height: 320px;
  border: 1px dashed rgba(64, 158, 255, 0.2);
  border-radius: 50%;
}

.orbit-node {
  position: absolute;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 5px 15px rgba(0, 0, 0, 0.05),
    0 10px 30px rgba(64, 158, 255, 0.1);
  z-index: 3;
  transition: transform 0.3s ease;
}

.orbit-node:hover {
  transform: scale(1.1);
}

.orbit-node.n1 {
  top: 18%;
  left: 50%;
  transform: translateX(-50%);
  animation: orbit-rotate 15s linear infinite;
}

.orbit-node.n2 {
  top: 65%;
  left: 25%;
  animation: orbit-rotate 15s linear infinite 5s;
}

.orbit-node.n3 {
  top: 65%;
  right: 25%;
  animation: orbit-rotate 15s linear infinite 10s;
}

@keyframes orbit-rotate {
  0% {
    transform: rotate(0deg) translateX(160px) rotate(0deg);
  }

  100% {
    transform: rotate(360deg) translateX(160px) rotate(-360deg);
  }
}

.node-icon {
  margin-bottom: 6px;
}

.node-icon i {
  font-size: 28px;
  background: linear-gradient(135deg, #409EFF 0%, #53a8ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.node-label {
  font-size: 14px;
  font-weight: 600;
  color: #409EFF;
}

.data-stream {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.stream-particle {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.8);
  animation: particle-flow 8s linear infinite;
  opacity: 0;
}

.stream-particle.p1 {
  animation-delay: 0s;
}

.stream-particle.p2 {
  animation-delay: 1.6s;
}

.stream-particle.p3 {
  animation-delay: 3.2s;
}

.stream-particle.p4 {
  animation-delay: 4.8s;
}

.stream-particle.p5 {
  animation-delay: 6.4s;
}

@keyframes particle-flow {
  0% {
    top: 18%;
    left: 50%;
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  45% {
    top: 65%;
    left: 25%;
    opacity: 1;
  }

  55% {
    top: 65%;
    left: 75%;
    opacity: 1;
  }

  90% {
    opacity: 1;
  }

  100% {
    top: 18%;
    left: 50%;
    opacity: 0;
  }
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .about-content {
    padding: 0 40px;
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .about-container {
    padding: 60px 0;
  }

  .about-content {
    flex-direction: column;
    padding: 0 20px;
    gap: 40px;
  }

  .section-title::before {
    font-size: 60px;
    top: -40px;
  }

  .company-name {
    font-size: 28px;
  }

  .technology-showcase {
    height: 400px;
  }

  .orbit-path {
    width: 270px;
    height: 270px;
  }

  @keyframes orbit-rotate {
    0% {
      transform: rotate(0deg) translateX(135px) rotate(0deg);
    }

    100% {
      transform: rotate(360deg) translateX(135px) rotate(-360deg);
    }
  }
}

/* 页脚 */
.home-footer {
  background-color: #303133;
  color: rgba(255, 255, 255, 0.7);
  padding: 30px 80px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links {
  display: flex;
  gap: 24px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #fff;
}

/* CTA区域 - 美化版 */
.cta-section {
  position: relative;
  padding: 0;
  overflow: hidden;
  margin: 80px 0 0;
}

.cta-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: linear-gradient(135deg, #3a8ee6 0%, #53a8ff 70%, #64b5f6 100%);
}

.cta-bg-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.cta-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.shape1 {
  width: 300px;
  height: 300px;
  top: -150px;
  right: 10%;
  animation: float-slow 20s infinite ease-in-out;
}

.shape2 {
  width: 200px;
  height: 200px;
  bottom: -100px;
  left: 15%;
  animation: float-slow 15s infinite ease-in-out reverse;
}

.shape3 {
  width: 120px;
  height: 120px;
  top: 40%;
  right: 20%;
  animation: float-slow 12s infinite ease-in-out 3s;
}

.cta-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  opacity: 0.5;
}

.cta-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 80px;
  display: flex;
  align-items: center;
  gap: 60px;
}

.cta-content {
  flex: 3;
  color: #fff;
}

.cta-title {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.cta-title span {
  position: relative;
  display: inline-block;
  padding: 0 8px;
  margin: 0 2px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  animation: pulse-highlight 3s infinite ease-in-out;
}

@keyframes pulse-highlight {

  0%,
  100% {
    background: rgba(255, 255, 255, 0.15);
  }

  50% {
    background: rgba(255, 255, 255, 0.25);
  }
}

.cta-description {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 600px;
  opacity: 0.9;
}

.cta-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.cta-button {
  background-color: #fff;
  color: #409EFF;
  border-color: #fff;
  padding: 15px 30px;
  font-size: 18px;
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.action-icon {
  margin-right: 8px;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.cta-button:hover .action-icon {
  transform: translateX(4px);
}

.cta-features {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.feature-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  font-size: 14px;
}

.feature-tag i {
  color: #fff;
  font-size: 14px;
}

.cta-visual {
  flex: 2;
  position: relative;
  height: 300px;
}

.visual-decoration {
  position: relative;
  width: 100%;
  height: 100%;
}

.deco-circle {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.deco-circle.c1 {
  width: 180px;
  height: 180px;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
}

.deco-circle.c2 {
  width: 240px;
  height: 240px;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  border-style: dashed;
}

.deco-circle.c3 {
  width: 120px;
  height: 120px;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.05);
  animation: pulse-subtle 3s infinite ease-in-out;
}

.deco-line {
  position: absolute;
  height: 2px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
}

.deco-line.l1 {
  width: 120px;
  top: 150px;
  left: 30px;
  transform: rotate(30deg);
}

.deco-line.l2 {
  width: 100px;
  top: 100px;
  right: 40px;
  transform: rotate(-20deg);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .cta-container {
    padding: 80px 40px;
  }
}

@media (max-width: 960px) {
  .cta-container {
    flex-direction: column;
    text-align: center;
  }

  .cta-content {
    margin-bottom: 40px;
  }

  .cta-actions {
    align-items: center;
  }

  .cta-description {
    margin-left: auto;
    margin-right: auto;
  }

  .cta-visual {
    height: 200px;
  }
}

@media (max-width: 768px) {
  .cta-container {
    padding: 60px 20px;
  }

  .cta-title {
    font-size: 32px;
  }

  .cta-description {
    font-size: 16px;
  }

  .cta-features {
    justify-content: center;
  }
}
</style>